// extracted by mini-css-extract-plugin
export default {"link_data_usage":"style_link_data_usage__8qrNT"};